import { GlobalService } from '../../shared/global.service';
import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Subscription } from 'rxjs';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';


@Component({
    selector: 'app-reg-ing-sal-cod-manual',
    templateUrl: './registrar-ing-sal-cod-manual.component.html',
    styleUrls: ['./registrar-ing-sal-cod.scss']
})
export class RegistroIngSalCodManualComponent implements OnDestroy {


    codigoFiltro: string;
    mensajeAlerta: string;
    public subscription: Subscription[] = [];

    constructor(private global: GlobalService, private router: Router
        , private urlService: UrlService, private spiner: NgxSpinnerService, private alertService: AlertService) {


    }

    /**
   * petición de consulta del código capturado
   */
    consultarCodigo() {

        if (this.codigoFiltro && this.codigoFiltro.length > 5) {

            this.spiner.show();

            const queryParams: Array<[string, string]> = new Array<[string, string]>();
            queryParams.push(['codigo', this.codigoFiltro]);
            const serviceProvider = 'ValidarCodigoTalanquera';
            const url = this.urlService.getUrl(new UrlControl(serviceProvider, queryParams, null), this.urlService.hostAPI_ACCVIS);
            const subs = this.global.getPublico(url).subscribe(
                data => {
                    this.mensajeAlerta = data[0].mensaje;

                    this.spiner.hide();
                    this.codigoFiltro = '';
                    if (data[0].visitaRespuesta) {
                        if (data[0].visitaRespuesta.estado == ConstantesService.ESTADO_AGENDA_ACTIVA_CON_ACTIVO) {
                            const fecha = data[0].visitaRespuesta.fechaInicioAgendada;
                            const f = fecha.split(' ');
                            var fechaFinal = f[0].split('-');
                            fechaFinal = fechaFinal[2] + '/' + fechaFinal[1] + '/' + fechaFinal[0];
                            const obj = {
                                agendaVisita: fechaFinal,
                                tipoIdVisitante: data[0].visitaRespuesta.tipoDocumentoVisitante,
                                numeroIdVisitante: data[0].visitaRespuesta.numeroDocumentoVisitante
                            }
                            this.global.zonaCompartida[VariablesZonaCompartida.OBJETO_VISITA] = obj;
                            this.router.navigate(['main/registro-salida-visitante']);
                        }
                    } else {
                        this.alertService.generateAlertError(this.mensajeAlerta, '');
                    }
                }, err => {
                    this.cathException(err.error.mensaje, err);
                }
            );
            this.subscription.push(subs);
        }
    }

    /**
  * Catch que genera una alaerta ene le componente cuando hay errores
  * @param err 
  * @author fromero
  */
    cathException(err, error) {
        this.spiner.hide();
        this.alertService.generateAlertError(err, '');
    }

    /*
  * destruye las subscripciones pendientes por gestionar 
  */
    ngOnDestroy() {
        this.subscription.forEach(subs => {
            subs.unsubscribe();
        });
    }


}
